import Container from "react-bootstrap/Container";
import FormSection from "../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../components/Faq";
import "../styles/dualEducation.css";
import "../styles/sliderCalculator.css";
import ResultsSection from "../components/ResultSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCheck, 
  faShieldAlt, 
  faChartLine, 
  faHandshake,
  faSearchDollar,
  faComments, 
  faUserTie, 
  faFilter, 
  faTools,
  faClock,
  faBolt,
  faHandHoldingUsd
} from "@fortawesome/free-solid-svg-icons";

export default function FrameworkContract() {
  const pricing = [
    { 
      label: "100 millió Ft alatt", 
      price: "150.000", 
      sub: "/ év + ÁFA",
      features: ["Éves pénzügyi audit", "Havi pályázatfigyelés", "Negyedéves konzultáció", "Pályázati előszűrés"]
    },
    { 
      label: "100–300 millió Ft között", 
      price: "300.000", 
      sub: "/ év + ÁFA",
      popular: true,
      features: ["Féléves teljes audit", "Kétheti pályázatfigyelés", "6 alkalmas konzultáció", "Hiteloptimalizálás", "Prioritásos elérés"]
    },
    { 
      label: "300 millió Ft felett", 
      price: "450.000", 
      sub: "/ év + ÁFA",
      features: ["Negyedéves mélyaudit", "Heti pályázatfigyelés", "Korlátlan konzultáció", "Teljes döntéstámogatás", "Egyedi kalkulációk"]
    },
  ];

  const services = [
    {
      icon: faSearchDollar,
      title: "Pénzügyi audit",
      desc: "Éves szintű banki, hitel- és finanszírozási átvilágítás a költségek minimalizálásáért."
    },
    {
      icon: faChartLine,
      title: "Pályázatfigyelés",
      desc: "Folyamatos monitoring és azonnali értesítés a cégedre szabott új kiírásokról."
    },
    {
      icon: faComments,
      title: "6–12 konzultáció",
      desc: "Rendszeres szakértői egyeztetés (online vagy személyes) a stratégiai döntésekhez."
    },
    {
      icon: faUserTie,
      title: "Prioritásos elérés",
      desc: "Kiemelt ügyfélként e-mailes és telefonos prioritást élvezel minden megkeresésnél."
    },
    {
      icon: faFilter,
      title: "Előszűrés",
      desc: "Minden pályázati és hitellehetőséget előminősítünk, mielőtt belevágnál."
    },
    {
      icon: faTools,
      title: "Döntéstámogatás",
      desc: "Exkluzív kalkulátorok, checklistek és dokumentációs sablonok a hatékony munkához."
    }
  ];

  return (
    <>
      <Container className="px-1 hero mx-md-auto text-center text-md-start">
        <span className="badge">STRATÉGIAI PARTNERSÉG</span>

        <h1 className="title">
          Éves pénzügyi partnerség – <br />
          <span style={{ color: "#c7d2fe" }}>folyamatos szakértői figyelem</span>
        </h1>

        <p className="subtitle">
          Nem eseti megbízásokat adunk, hanem <strong>folyamatos rendelkezésre állást</strong>. 
          Segítünk a vállalkozásod pénzügyi döntéseiben, figyeljük a pályázatokat és 
          optimalizáljuk a hiteleidet az év minden napján.
        </p>

        <div className="cta justify-content-center justify-content-md-start">
          <Button href="#szolgaltatasok" className="btn btn-primary">
            Mit kap a cégem?
          </Button>

          <Button href="#pricing" className="btn btn-secondary">
            Díjstruktúra
          </Button>
        </div>
      </Container>

      <Container>
        {/* Core Pillars Section */}
        <section className="section">
          <Row className="g-3">
            <Col md={4}>
              <Card className="card h-100 border-0 bg-dark-soft">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="p-2 rounded-3 bg-warning-soft">
                    <FontAwesomeIcon icon={faShieldAlt} className="fs-4 text-warning" />
                  </div>
                  <h3 className="h5 mb-0 fw-bold">Pénzügyi biztonság</h3>
                </div>
                <div className="muted small">
                  Folyamatos kontroll a cég finanszírozási szerkezete felett, hogy elkerüld a felesleges költségeket.
                </div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card h-100 border-0 bg-dark-soft">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="p-2 rounded-3 bg-warning-soft">
                    <FontAwesomeIcon icon={faChartLine} className="fs-4 text-warning" />
                  </div>
                  <h3 className="h5 mb-0 fw-bold">Proaktív növekedés</h3>
                </div>
                <div className="muted small">
                  Nem maradsz le egyetlen támogatásról sem, mert mi helyetted is figyeljük a lehetőségeket.
                </div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card h-100 border-0 bg-dark-soft">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="p-2 rounded-3 bg-warning-soft">
                    <FontAwesomeIcon icon={faHandshake} className="fs-4 text-warning" />
                  </div>
                  <h3 className="h5 mb-0 fw-bold">Kiemelt figyelem</h3>
                </div>
                <div className="muted small">
                  Saját külsős pénzügyi osztályodként működünk, akihez bármikor fordulhatsz kérdéssel.
                </div>
              </Card>
            </Col>
          </Row>
        </section>

        {/* Value Proposition Section */}
        <section className="section py-5">
          <div className="text-center mb-5">
            <h2 className="h2">Miért a stratégiai partnerség a legjobb döntés?</h2>
            <p className="lead opacity-75">Értékteremtés, nem csak adminisztráció</p>
          </div>

          <Row className="g-4">
            <Col lg={4} md={6}>
              <Card className="card h-100 border-0 bg-dark-soft p-4">
                <div className="mb-3 text-warning">
                  <FontAwesomeIcon icon={faHandHoldingUsd} className="fs-2" />
                </div>
                <h4 className="h5 fw-bold mb-3">Veszteségelkerülés</h4>
                <p className="small opacity-90 mb-0">
                  A legtöbb cég nem azért választ minket, hogy pályázzon, hanem hogy <strong>ne hagyjon bent pénzt a rendszerben</strong>. Egyetlen elszalasztott pályázat ára tipikusan 20–200 millió Ft – mi biztosítjuk, hogy Ön minden forrást kihasználjon.
                </p>
              </Card>
            </Col>

            <Col lg={4} md={6}>
              <Card className="card h-100 border-0 bg-dark-soft p-4">
                <div className="mb-3 text-warning">
                  <FontAwesomeIcon icon={faUserTie} className="fs-2" />
                </div>
                <h4 className="h5 fw-bold mb-3">„Hely az asztalnál”</h4>
                <p className="small opacity-90 mb-0">
                  Nem csupán pályázatírók vagyunk. A stratégiai pénzügyi döntéseknél <strong>ott ülünk Önnel az asztalnál</strong>. A retainer alapú együttműködés valódi partneri szerepet és folyamatos szakmai hátteret jelent projektalapú megbízások helyett.
                </p>
              </Card>
            </Col>

            <Col lg={4} md={6}>
              <Card className="card h-100 border-0 bg-dark-soft p-4">
                <div className="mb-3 text-warning">
                  <FontAwesomeIcon icon={faBolt} className="fs-2" />
                </div>
                <h4 className="h5 fw-bold mb-3">A gyorsaság pénzt ér</h4>
                <p className="small opacity-90 mb-0">
                  A pályázatok 30–50%-a a gyors reakción múlik. Partnerként <strong>Ön prioritást élvez</strong>: amint megnyílik egy lehetőség, azonnal lépünk. Aki csak a beadási fázisban keres szakértőt, már hátrányból indul.
                </p>
              </Card>
            </Col>

            <Col lg={6} md={6}>
              <Card className="card h-100 border-0 bg-dark-soft p-4 border-warning border-opacity-10">
                <div className="mb-3 text-warning">
                  <FontAwesomeIcon icon={faShieldAlt} className="fs-2" />
                </div>
                <h4 className="h5 fw-bold mb-3">Biztonság a változó környezetben</h4>
                <p className="small opacity-90 mb-0">
                  Ön nem egy-egy pályázatra fizet, hanem arra, hogy <strong>mindig tudja, merre van a pénz</strong>. Folyamatosan monitorozzuk a gazdasági környezetet és előre látjuk a finanszírozási irányokat, így Önnek nem kell aggódnia a bizonytalanság miatt.
                </p>
              </Card>
            </Col>

            <Col lg={6} md={12}>
              <Card className="card h-100 border-0 bg-warning-soft p-4 border-warning border-opacity-20">
                <div className="mb-3 text-warning">
                  <FontAwesomeIcon icon={faClock} className="fs-2" />
                </div>
                <h4 className="h5 fw-bold mb-3">Vezetői hatékonyság</h4>
                <p className="small opacity-90 mb-0">
                  A tulajdonos ideje a legdrágább erőforrás. <strong>Egyetlen rossz finanszírozási döntés</strong> többe kerülhet, mint a keretszerződésünk több éves díja. Mi levesszük a válláról a monitoring és az elemzés terhét, hogy Ön az üzletépítésre koncentrálhasson.
                </p>
              </Card>
            </Col>
          </Row>
        </section>

        {/* Detailed Services Section */}
        <section id="szolgaltatasok" className="section">
          <div className="text-center mb-5">
            <h2 className="h2">Mit adunk a keretszerződésért?</h2>
            <p className="lead opacity-75">Kötelező alapszolgáltatások, amelyek minden partnerünknek járnak:</p>
          </div>
          
          <Row className="g-4">
            {services.map((service, index) => (
              <Col md={4} key={index}>
                <Card className="card h-100 border-0 shadow-sm hover-lift">
                  <div className="mb-3" style={{ color: "var(--warning-color)" }}>
                    <FontAwesomeIcon icon={service.icon} className="fs-2" />
                  </div>
                  <h4 className="h5 fw-bold mb-3" style={{ color: "var(--title-color)" }}>
                    {service.title}
                  </h4>
                  <p className="small opacity-75 mb-0">
                    {service.desc}
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* Roadmap Section */}
        <section className="section">
          <div className="text-center mb-5">
            <h2 className="h2">Hogyan dolgozunk együtt?</h2>
            <p className="lead opacity-75">Az első 12 hónap ütemterve</p>
          </div>
          <Row className="g-4">
            <Col md={3}>
              <div className="text-center">
                <div className="step-number mb-3">1</div>
                <h4 className="h6 fw-bold">Audit & Start</h4>
                <p className="small opacity-75">Az első hónapban átvilágítjuk a banki költségeket és a hiteleket. Azonnali spórolási pontokat keresünk.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center">
                <div className="step-number mb-3">2</div>
                <h4 className="h6 fw-bold">Pályázati profil</h4>
                <p className="small opacity-75">Felállítjuk a cég pályázati profilját, hogy csak a releváns lehetőségekről kapj értesítést.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center">
                <div className="step-number mb-3">3</div>
                <h4 className="h6 fw-bold">Monitorozás</h4>
                <p className="small opacity-75">Folyamatosan figyeljük a piacot és negyedévente egyeztetünk a stratégiai irányokról.</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center">
                <div className="step-number mb-3">4</div>
                <h4 className="h6 fw-bold">Növekedés</h4>
                <p className="small opacity-75">Végigkísérünk a pályázati és hitelfolyamatokon, biztosítva a sikeres forrásbevonást.</p>
              </div>
            </Col>
          </Row>
        </section>

        {/* Pricing Section */}
        <section id="pricing" className="section">
          <div className="text-center mb-5">
            <h2 className="h2">Átlátható, sávos éves díjazás</h2>
            <p className="lead opacity-75">Válaszd a céged éves árbevétele alapján kialakított csomagunkat</p>
          </div>
          
          <Row className="g-4 justify-content-center align-items-stretch">
            {pricing.map((tier, index) => (
              <Col lg={4} md={6} key={index}>
                <Card className={`card h-100 border-0 p-4 ${tier.popular ? 'bg-warning-soft border border-warning border-opacity-20 shadow-lg' : 'bg-dark-soft'}`} 
                      style={tier.popular ? { transform: 'scale(1.02)', zIndex: 1 } : {}}>
                  {tier.popular && (
                    <div className="badge bg-warning text-dark position-absolute top-0 start-50 translate-middle">NÉPSZERŰ</div>
                  )}
                  <div className="text-center mb-4 mt-2">
                    <div className="small text-uppercase tracking-wider opacity-75 mb-3 fw-bold">{tier.label}</div>
                    <div className="revenue-value" style={{ fontSize: '3rem', color: 'var(--warning-color)' }}>
                      {tier.price} <span className="fs-5 opacity-75">Ft</span>
                    </div>
                    <div className="small opacity-50 fw-bold">{tier.sub}</div>
                  </div>
                  
                  <hr className="border-white border-opacity-10 mb-4" />
                  
                  <ul className="list-unstyled space-y-3 mb-0 flex-grow-1">
                    {tier.features.map((feature, fIndex) => (
                      <li key={fIndex} className="d-flex align-items-start gap-2 mb-3 small">
                        <FontAwesomeIcon icon={faCheck} className="text-warning mt-1" style={{ fontSize: '14px' }} />
                        <span className="opacity-90">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Button 
                    href="#leadform" 
                    className={`btn w-100 mt-4 ${tier.popular ? 'btn-primary' : 'btn-secondary'}`}
                  >
                    Ezt választom
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        <section className="section bg-warning-soft rounded-4 p-5 text-center my-5 border border-warning border-opacity-20 shadow-lg">
          <h2 className="h2 mb-4">Kiemelt ügyfélkör, korlátozott létszám</h2>
          <p className="lead mb-4 mx-auto" style={{ maxWidth: "800px" }}>
            Mivel minden partnerünknek <strong>személyes figyelmet</strong>, 24 órán belüli visszahívást és 
            folyamatos szakértői jelenlétet biztosítunk, évente csak korlátozott számú új 
            keretszerződést kötünk. 
          </p>
          <p className="small opacity-90 mb-4">
            <em>Jelenleg még 3 szabad helyünk van a negyedévre.</em>
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <Button href="#leadform" className="btn btn-primary btn-lg px-5 shadow-lg">
              Biztosítom a helyem
            </Button>
            <Button href="#szolgaltatasok" className="btn btn-secondary btn-lg px-5">
              Átnézem a szolgáltatásokat
            </Button>
          </div>
        </section>

        <Container id="leadform" className="mt-5">
          <h2 className="h2 text-center">Érdekel a partnerség?</h2>
          <p className="text-center mb-5 opacity-75">
            Add meg az adataidat, és 24 órán belül visszahívunk az együttműködés részleteivel!
          </p>
          <Row className="justify-content-center">
            <Col md={6}>
              <FormSection formType="Keretszerződés" />
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section">
          <h2 className="h2">Gyakran ismételt kérdések</h2>
          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Miért jó a keretszerződés?",
                    answer:
                      "Mert nem csak akkor beszélünk, amikor már baj van vagy ég a ház. Folyamatosan figyeljük a lehetőségeidet, így nem maradsz le egyetlen pályázatról vagy kedvező hitelről sem. Ez egy proaktív biztonsági háló a cégednek.",
                  },
                  {
                    question: "Mikor kell fizetni a díjat?",
                    answer:
                      "A keretszerződés díja éves díj, melyet a szerződéskötéskor, egy összegben kell rendezni. Ez biztosítja a prioritást és a folyamatos rendelkezésre állást az év során.",
                  },
                  {
                    question: "Ez kiváltja a könyvelőt?",
                    answer:
                      "Nem, mi nem könyvelünk. Mi pénzügyi stratégiai partnerek vagyunk, akik a finanszírozásra, pályázatokra és a banki költségek optimalizálására fókuszálnak – kiegészítve a könyvelőd munkáját. Mi a növekedésre és a költségcsökkentésre koncentrálunk.",
                  },
                ],
              },
            ]}
          />
        </section>

        <Container className="py-5">
          <ResultsSection />
        </Container>
      </Container>
    </>
  );
}
